import {ForceToArray, ObjectOrArrayMap} from "@/base/utils/arrayutils";

export type PageOutput<T> = {
	current_page?: number;
	last_page?: number;
	per_page?: number;
	total?: number;
	from?: number;
	to?: number;
	data?: T[];
	full_data?: T[][];
}

export const DefaultPageOutput: PageOutput<any> = {
	current_page: 1,
	last_page: 1,
	per_page: 10,
	total: 0,
	from: 0,
	to: 0,
	full_data: [],
	data: []
}

export const getDefaultPageOutput = (size: number = 25): PageOutput<any> => {
	return {
		current_page: DefaultPageOutput.current_page,
		last_page: DefaultPageOutput.last_page,
		per_page: size,
		total: DefaultPageOutput.total,
		from: DefaultPageOutput.from,
		to: DefaultPageOutput.to,
		data: []
	}
}

export type SortOrder = "desc" | "asc" | null;
export type SortChangeCallback = (key: string, order: SortOrder) => void

export function SortAppend(value: Record<string, any>, setValue: (v: any) => void, key: string, order: SortOrder) {
	// store sort in sort-by key or delete if order null
	if (!order && value["sort-by"] == key)
	{
		const nP = {...value};
		delete nP["sort-by"];
		delete nP["sort-order"];

		setValue(nP);
		return;
	}

	// if values already set dont change
	if (value["sort-by"] == key && value["sort-order"] == order)
	{
		return;
	}

	setValue({
		...value,
		"sort-by": key,
		"sort-order": order
	})
}

export const MapPageOutput = <T>(data: any, mapFn: (d: any) => T = (t) => t): PageOutput<T> => {
	return {
		...data,
		current_page: data.current_page || DefaultPageOutput.current_page,
		last_page: data.last_page || DefaultPageOutput.last_page,
		per_page: data.per_page || DefaultPageOutput.per_page,
		total: data.total || DefaultPageOutput.total,
		from: data.from || DefaultPageOutput.from,
		to: data.to || DefaultPageOutput.to,
		data: ForceToArray(ObjectOrArrayMap((data.data || DefaultPageOutput.data) as any[], mapFn))
	}
}

export const DataPageOutput = <T>(T: T[], mapFn: (d: any) => T = (t) => t, perPage: number | null = null): PageOutput<T> => {
	let mapped = T.map(mapFn);

	let full = [];
	if (perPage && mapped.length > perPage)
	{
		for (let i = 0; i < mapped.length; i += perPage)
		{
			full.push(mapped.slice(i, i + perPage));
		}
		mapped = full[0] || mapped;
	}

	return {
		current_page: DefaultPageOutput.current_page,
		last_page: full && full.length > 0 ? full.length : DefaultPageOutput.last_page,
		per_page: perPage || DefaultPageOutput.per_page,
		total: full && full.length > 0 ? full.map((f) => f.length).reduce((a, b) => a + b) : mapped.length,
		from: DefaultPageOutput.from,
		to: DefaultPageOutput.to,
		full_data: full,
		data: mapped
	}
}